import React, { useState } from 'react'
import { Avatar, Popover } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { UserProfileMenu } from './user-profile-menu'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { getDataOfType } from 'src/lib/utils/get-data-of-type'

const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)

const UserProfileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 270px;
  height: 46px;
  padding: 3px 12px 3px 4px;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  background: #f8f9fb;
  color: #202735;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;

  &:hover,
  &[aria-expanded='true'] {
    background: #fff;
    border-color: #cdd3e1;
    box-shadow: 0 2px 8px rgba(22, 31, 50, 0.08);
  }

  &:focus-visible {
    outline: 2px solid var(--system-focus, #606a91);
    outline-offset: 2px;
  }

  @media (max-width: 1024px) {
    width: 220px;
  }
`

const StyledAvatar = styled(Avatar)`
  flex: none;
  background-color: #52c41a;
  font-size: 12px !important;
`

const UserDetails = styled.span`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
`

const UserName = styled.span`
  overflow: hidden;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const OfficeName = styled.span`
  overflow: hidden;
  color: #747e97;
  font-size: 11px;
  line-height: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Chevron = styled(DownOutlined)`
  flex: none;
  color: #6d7590;
  font-size: 10px;
`

export const UserProfile = () => {
  const { sessionData } = useSelector(createSession)
  const [open, setOpen] = useState(false)
  const fullName = String(sessionData?.user?.name || '').trim()
  const login = String(sessionData?.user?.login || '').trim()
  const name = fullName || login || 'Пользователь ERP'
  const officeName = getDataOfType(sessionData, 'user.office.name', String, '').trim()
  const avatarUrl = sessionData?.user?.avatar_url
  const initials = name
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase()

  return (
    <Popover
      placement="bottomRight"
      content={
        <UserProfileMenu
          name={name}
          officeName={officeName}
          initials={initials}
          avatarUrl={avatarUrl}
          onClose={() => setOpen(false)}
        />
      }
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      overlayInnerStyle={{ padding: 0, borderRadius: 8 }}
    >
      <UserProfileButton
        type="button"
        aria-label={`Профиль: ${name}`}
        aria-expanded={open}
        title={name}
      >
        <StyledAvatar size={38} src={avatarUrl || undefined}>
          {initials}
        </StyledAvatar>
        <UserDetails>
          <UserName>{name}</UserName>
          {officeName && <OfficeName>{officeName}</OfficeName>}
        </UserDetails>
        <Chevron />
      </UserProfileButton>
    </Popover>
  )
}
